import React, { useState, PropsWithChildren, ErrorInfo } from 'react';
import { useFullReset } from '../../context/Kiosk/kiosk';
import { useLocalization } from '../../context/Localization/localization';
import { GMDialogInfo } from '../../controls/Dialog';

export const ErrorBoundary: React.FC<React.PropsWithChildren<unknown>> = (props) => {
    const resetKiosk = useFullReset();
    const [error, setError] = useState(false);
    const Localization = useLocalization();

    return (
        <>
            <ErrorBoundaryBase {...props} onError={() => setError(true)} />
            <GMDialogInfo
                ariaLabel={Localization.AnUnknownErrorHasOccurred}
                ariaDescribedBy={Localization.AnUnknownErrorHasOccurred}
                open={error}
                onClose={resetKiosk}
                title={Localization.AnUnknownErrorHasOccurred}
            >
                <div id={Localization.AnUnknownErrorHasOccurred}>
                    {Localization.PleaseContactAServiceRepresentative}
                </div>
            </GMDialogInfo>
        </>
    );
};

export const ErrorBoundaryFull: React.FC<React.PropsWithChildren<unknown>> = (props) => {
    const [error, setError] = useState(false);

    return (
        <>
            <ErrorBoundaryBase {...props} onError={() => setError(true)} />
            {error && <div>{'Something went wrong'}</div>}
        </>
    );
};

export interface IProps {
    onError: () => void;
}
export class ErrorBoundaryBase extends React.Component<PropsWithChildren<IProps>, { hasError: boolean; }> {
    constructor(props: IProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // You can also log the error to an error reporting service
        console.log(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            this.props.onError();

            return null;
        }

        return this.props.children;
    }
}